export default "__VITE_ASSET__CnI2kejS__"